import axios from "axios";
import * as actionType from "../../../constant/actionType";
export const UpdateDraftInvoice = (ApiData) => async (dispatch) => {
  try {
    const response = await axios({
      method: "put",
      data: ApiData,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/admin/UpdateDraftInvoice`,
    });
    return response.data;
  } catch (error) {
    return error.message;
  }
};
